import { ContextMenuInputPoint, } from '@thoughtspot/chart-common';
import { getId } from '@thoughtspot/visualization-column-util';
import _ from 'lodash';
import { getDisplayValue } from '../data/data-util';
import { getColumn } from './chart-model-utils';
export const getTableColumnByCustomOrder = (columnOrder, userDefinedColumnOrder) => {
    const order = [];
    let visibleIndex;
    let customOrderIndex = userDefinedColumnOrder.length;
    userDefinedColumnOrder.forEach((col, index) => {
        order[col] = index;
    });
    const customColumnOrder = columnOrder.map(colId => {
        if (_.isNumber(order[colId])) {
            visibleIndex = order[colId];
        }
        else {
            visibleIndex = customOrderIndex;
            customOrderIndex++;
        }
        return { colId, visibleIndex };
    });
    return _.map(_.sortBy(customColumnOrder, 'visibleIndex'), 'colId');
};
export const getOrderedTableColumns = (tableViz) => {
    var _a;
    const columnOrder = (_a = tableViz.vizProp) === null || _a === void 0 ? void 0 : _a.orderedColumnIds;
    const columns = _.map(tableViz.columns, 'column');
    const columnIds = _.map(columns, (column) => getId(column));
    const columnIdsInOrder = !_.isEmpty(columnOrder)
        ? getTableColumnByCustomOrder(columnIds, columnOrder)
        : columnIds;
    return _.sortBy(columns, column => columnIdsInOrder.indexOf(column.id));
};
export const getHiddenTableColumnIds = (tableViz) => {
    var _a;
    const hiddenColumns = [];
    (((_a = tableViz === null || tableViz === void 0 ? void 0 : tableViz.vizProp) === null || _a === void 0 ? void 0 : _a.columnProperties) || []).forEach(prop => {
        var _a;
        if ((_a = prop === null || prop === void 0 ? void 0 : prop.columnProperty) === null || _a === void 0 ? void 0 : _a.isHidden) {
            hiddenColumns.push(prop === null || prop === void 0 ? void 0 : prop.columnId);
        }
    });
    return hiddenColumns;
};
export const getOrderedVisibleTableColumns = (tableViz) => {
    const columns = getOrderedTableColumns(tableViz);
    const hiddenColumns = new Set(getHiddenTableColumnIds(tableViz));
    return columns.filter((col) => !hiddenColumns.has(col.id));
};
export const getOrderedHiddenTableColumns = (tableViz) => {
    const columns = getOrderedTableColumns(tableViz);
    const hiddenColumns = new Set(getHiddenTableColumnIds(tableViz));
    return columns.filter((col) => hiddenColumns.has(col.id));
};
export const getVisibleTableColumnIds = (tableViz) => {
    var _a;
    const hiddenColumns = new Set(getHiddenTableColumnIds(tableViz));
    const visibleColumns = [];
    (_a = tableViz === null || tableViz === void 0 ? void 0 : tableViz.columns) === null || _a === void 0 ? void 0 : _a.forEach((col) => {
        if ((col === null || col === void 0 ? void 0 : col.column) && !hiddenColumns.has(col.column.id)) {
            visibleColumns.push(col.column.id);
        }
    });
    return visibleColumns;
};
export const getContextMenuClickedPointForTableColumn = (tableViz, rowData, selectedColumns, translateString) => {
    const contextMenuClickedPoint = new ContextMenuInputPoint();
    getOrderedTableColumns(tableViz).forEach((column, idx) => {
        const vizColumn = getColumn(tableViz, column.id);
        const backendValue = rowData[vizColumn.id];
        const value = getDisplayValue(backendValue, translateString);
        if (vizColumn) {
            const inputValue = {
                column: vizColumn,
                value,
            };
            if (selectedColumns.includes(vizColumn.id)) {
                contextMenuClickedPoint.pushSelected(inputValue);
            }
            else {
                contextMenuClickedPoint.pushDeselected(inputValue);
            }
        }
    });
    return contextMenuClickedPoint;
};
export const getContextMenuSelectedPointsForTableColumn = (tableViz, rowsData, selectedColumns, translateString) => {
    const contextMenuSelectedPoints = [];
    rowsData.forEach(rowData => {
        const contextMenuClickedPoint = getContextMenuClickedPointForTableColumn(tableViz, rowData, selectedColumns, translateString);
        contextMenuSelectedPoints.push(contextMenuClickedPoint);
    });
    return contextMenuSelectedPoints;
};
//# sourceMappingURL=table-utils.js.map